<template>
    <iframe class="fullscreen-iframe" @load="loadEnded" />
</template>

<script setup>

    import { onMounted } from 'vue';

    const emit = defineEmits(['loading']);

    onMounted(() => {
        emit('loading', true);
    });

    function loadEnded() {
        emit('loading', false);
    }
</script>

<style lang="scss">
    .fullscreen-iframe {
        width: 100%;
        height: 100%;
        border: none;
        padding: 0;
        margin: 0;
    }
</style>
